<div class="tituloPantalla">
    <mat-toolbar style="height: 33px;" fxLayout class="tituloPantalla">
        <h3 class="title">Bandeja de Tareas</h3>
    </mat-toolbar>
</div>

        <form [formGroup]="group"  class="a-example-full-width-alterno-content" style="margin: 0px !important; padding: 4vh 0vh;">

            <div class="a-example-full-width-alterno-content-column">

                <div class=" a-example-full-width-alterno-content">

                    <div class="a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content-2">
                            <p-floatLabel class="w-full md:w-56" variant="on">
                                <input pInputText class="w-full md:w-56"
                                    formControlName="nombreproyecto" appendTo="body" />
                                <label for="on_label">Nombre de proyecto</label>
                            </p-floatLabel>
                        </div>


                        <div class="a-example-full-width-alterno-content-2">
                            <p-floatLabel class="w-full md:w-56" variant="on">
                                <p-datepicker formControlName="fechaInicio"
                                    appendTo="body" [showIcon]="true" [showWeek]="false" styleClass="w-full md:w-56"
                                    dateFormat="dd/mm/yy">
                                </p-datepicker>
                                <label for="on_label">Fecha Desde</label>
                            </p-floatLabel>
                        </div>
    
                        <div class="a-example-full-width-alterno-content-2">
                            <p-floatLabel class="w-full md:w-56" variant="on">
                                <p-datepicker formControlName="fechaFin"
                                    appendTo="body" [showIcon]="true" [showWeek]="false" styleClass="w-full md:w-56"
                                    dateFormat="dd/mm/yy">
                                </p-datepicker>
                                <label for="on_label">Fecha Hasta</label>
                            </p-floatLabel>
                        </div>

                        <div class="a-example-full-width-alterno-content-2">
                            <p-floatLabel class="w-full md:w-56" variant="on">
                                <p-select [options]="ListaEstadosProyecto"
                                    placeholder="‎ " optionLabel="nombre" formControlName="estado" optionValue="codigo"
                                    appendTo="body" styleClass="w-full md:w-56">
                                </p-select>
                                <label for="on_label">Estado</label><!--[options]="ListaEstadosProyecto"-->
                            </p-floatLabel>
                        </div>


                        <div class="a-example-full-width-alterno-content-row-buttons">

                            <div class="a-example-full-width-alterno-content-3">
                                <div class="a-example-full-width-alterno-content-2" style="display: flex; justify-content: center;">                            
                                    <p-button icon="pi pi-search" severity="info"
                                        (click)="buscar()" pTooltip="Buscar" tooltipPosition="bottom"></p-button>
                                </div>
                            </div>
        
        
                            <div class="a-example-full-width-alterno-content-3">
                                <div class="a-example-full-width-alterno-content-2" style="display: flex; justify-content: center;">                            
                                    <p-button icon="pi pi-file" severity="info"
                                        (click)="agregarTarea()" pTooltip="Nueva Tarea" tooltipPosition="bottom"></p-button>
                                </div>
                            </div>

                            <div class="a-example-full-width-alterno-content-3">
                                <div class="a-example-full-width-alterno-content-2" style="display: flex; justify-content: center;">                            
                                    <p-button icon="pi pi-sign-out" severity="info"
                                        (click)="salir('')" pTooltip="Salir" tooltipPosition="bottom"></p-button>
                                </div>
                            </div>
                        </div>

                    </div>



                </div>



            </div>
            <!-- <div fxLayoutGap="20px" class="label">
                <mat-form-field class="example-full-width-alterno3" appearance="outline">
                    <mat-label>Nombre de proyecto</mat-label>
                    <input matInput type="text" placeholder="Nombre de proyecto" formControlName="nombreproyecto">
                </mat-form-field>
                <mat-form-field appearance="outline" class="example-full-width-alterno3">
                    <mat-label>Fecha Desde</mat-label>
                    <input formControlName="fechaInicio" matInput [matDatepicker]="picker1" autocomplete="off" readonly
                        [disabled]="true" (dateChange)="onDateChangeDesde($event,'fechaInicio')">
                    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 color="primary"></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" class="example-full-width-alterno3">
                    <mat-label>Fecha Hasta</mat-label>
                    <input formControlName="fechaFin" matInput [matDatepicker]="picker2" autocomplete="off" readonly
                        [disabled]="true" (dateChange)="onDateChangeDesde($event,'fechaFin')">
                    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2 color="primary"></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="example-full-width-alterno3" appearance="outline">
                    <mat-label>Estado</mat-label>
                    <mat-select placeholder="Estado" formControlName="estado">
                        <mat-option value="">TODOS</mat-option>
                        <mat-option value="N">NUEVO</mat-option>
                        <mat-option value="P">PLANIFICADO</mat-option>
                        <mat-option value="E">EN CURSO</mat-option>
                        <mat-option value="R">EN REVISION</mat-option>
                        <mat-option value="C">COMPLETADO</mat-option>
                    </mat-select>
                </mat-form-field>
                <button mat-raised-button class="button1" (click)="buscar()">Buscar</button>
                <button mat-raised-button class="button1" (click)="agregarTarea()">Nueva tarea</button>
                <button mat-raised-button class="button1" (click)="salir('')">Salir</button>
            </div> -->
        </form>

        <div class="a-example-full-width-alterno-content">
            <app-datatable [dataTable]="eventostareas_dataeventos" [metadataTable]="metadatableDataEventos"
                [filter]="true" [addRow]="false" [rowDialog]="true" [rowEdit]="false" [key]="'id'" >
                <ng-template #addHeaderStart>
                    <th class="header">
                        <div class="items-header">
                            <span>Acción</span>
                        </div>
                    </th>
                </ng-template>
                <ng-template #addBodyStart let-row="row">
                        <td class="a-datatable-datos-body-accion row-space" >
                            <p-confirmPopup></p-confirmPopup>


                            <p-button icon="pi pi-plus" [rounded]="true" severity="success"
                            (onClick)="agregarSubTareas('',row)" pTooltip="Agregar" tooltipPosition="top"></p-button>

                            <p-button icon="pi pi-pencil" [rounded]="true" severity="info"
                            (onClick)="editar('',row)" pTooltip="Editar" tooltipPosition="top"></p-button>
                            
                           



                            <!-- <button mat-raised-button class="button2 button-spacing" (click)="agregarSubTareas('',row)">Agregar Tarea</button>
                            <button mat-raised-button class="button2 button-spacing" (click)="editar('',row)">Editar</button> -->


                            
                            <!-- <button mat-raised-button class="button2" (click)="editarEstado('',row)">Estado</button> -->

                        </td>
                </ng-template>
            </app-datatable>
        </div>
<footer>
    <div class="contenido-pie">
      <p></p>
    </div>
  </footer>




  <style>
    .p-inputtext {
     width: 100%;
    }
    
    ::ng-deep .p-calendar {
        width: 100%;
        /* height: 47px; */
    }
    /* .button-width{
        width: 100%;
    } */

    .button-width{
        width: 100%;
        display: flex;
        justify-content: center;
        
    }
    ::ng-deep .p-button{
        width: 50%;
        margin: auto;
    }
    :host ::ng-deep .p-dropdown {
        width: 100%;
        height: 100%;
        /* height: 47px; */
    }


    :host ::ng-deep .p-tabview .p-tabview-panels {
        padding: 5px;
    }

    :host ::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
        padding: 7px;
    }

    p-tabView>p-tabPanel {
        width: 500px;
    }
</style>

